/* Not exported with the library. You'll want something similar to this for uniquely identifying external hosts in your App */
const CONNECT = Symbol("CONNECT");
const IDADMIN = Symbol("IDADMIN");

export const apiHosts = {
  CONNECT,
  IDADMIN,
};
